import React from "react";
import { Box, Typography } from "@mui/material";

const ActivityTimeline = ({ activity }) => {
  if (!activity || activity.length === 0) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: "center", padding: 2 }}
      >
        No recent activity in the last 2 weeks.
      </Typography>
    );
  }

  return (
    <Box sx={{ marginTop: 3, padding: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
        Recent Activity
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {activity.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              borderLeft: "3px solid #007bff",
              paddingLeft: 2,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ minWidth: 80, textAlign: "right" }}
            >
              {new Date(item.date).toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
              })}
            </Typography>
            <Typography variant="body1">{item.message}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ActivityTimeline;
